'use strict';

require('./cn-autosaver.scss');

module.exports = {
  template: require('./cn-autosaver.html'),
  controller: require('./cn-autosaver.controller'),
  controllerAs: 'vm',

  bindings: {
    formFields: '<',
    onSave: '&'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/app/components/cn-autosaver/index.js
 ** module id = 132
 ** module chunks = 0
 **/